import { render, staticRenderFns } from "./TranslationsKey.vue?vue&type=template&id=15da9d1a"
import script from "./TranslationsKey.vue?vue&type=script&lang=js"
export * from "./TranslationsKey.vue?vue&type=script&lang=js"
import style0 from "./TranslationsKey.vue?vue&type=style&index=0&id=15da9d1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports